import { t } from '../i18n.js';

/** Voor een scherm waar je een recht voor nodig hebt dat je niet hebt. */
export function GeenToegang() {
  return (
    <div className="page-head"><div>
      <h1>{t('Geen toegang')}</h1>
      <p className="sub">{t('Voor dit scherm heb je een recht nodig dat je niet hebt.')}</p>
    </div></div>
  );
}

/** Aangemeld, maar nog zonder rol: zo komt een nieuw ADTS-account binnen. */
export function NogGeenRechten({ naam }) {
  return (
    <div className="page-head"><div>
      <h1>{t('Nog geen rechten')}</h1>
      <p className="sub">{t('Je bent aangemeld als {naam}, maar je hebt nog geen rol waarmee je iets in ADTS ZERO kunt zien. Vraag een collega met het recht Rechten beheren om je een rol en klanten te geven.', { naam })}</p>
    </div></div>
  );
}
